import { Button, BackTop, Divider, Form, Input } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';

export default function Step2({ ...props }) {
    const { setStep2, editData } = props;
    const { t } = useTranslation(['hr-policy', 'translation']);

    const onNextStep = () => {
        props?.form
            .validateFields()
            .then(() => {
                setStep2(true);
            })
            .catch(() => setStep2(false));
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (editData) {
            let check = true;
            const allowKey = [
                'vendorIntroductionLawfulBasisId',
                'vendorIntroductionTitleTh',
                'vendorIntroductionTitleEn',
                'vendorIntroductionContentTh',
                'vendorLawfulBasisTitleTh',
                'vendorLawfulBasisTitleEn',
                'vendorLawfulBasisContentTh',
            ];
            for (const [key, value] of Object.entries(
                editData?.vendorIntroductionLawfulBasis
            )) {
                if (allowKey.includes(key) && !value) {
                    check = false;
                }
            }
            setStep2(check);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editData]);

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Introduction and Lawful Basis')}
            </div>
            <div className="text-gray-500 text-tiny">
                {t('policy.desEtc', { ns: 'translation' })}
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="vendorIntroductionLawfulBasis"
                layout="vertical"
                form={props?.form}
                onValuesChange={(e, allFields) => {
                    let check = true;
                    const allowKey = [
                        'vendorIntroductionLawfulBasisId',
                        'vendorIntroductionTitleTh',
                        'vendorIntroductionTitleEn',
                        'vendorIntroductionContentTh',
                        'vendorLawfulBasisTitleTh',
                        'vendorLawfulBasisTitleEn',
                        'vendorLawfulBasisContentTh',
                    ];
                    for (const [key, value] of Object.entries(allFields)) {
                        if (allowKey.includes(key) && !value) {
                            check = false;
                        }
                    }
                    setStep2(check);
                }}
                initialValues={initial}
            >
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Introduction')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorIntroductionTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`เพื่อให้ บริษัท [company_name] (“บริษัท”) สามารถดำเนินกระบวนการจัดซื้อจัดจ้างท่านได้\nกรุณาศึกษานโยบายข้อมูลส่วนบุคคลฉบับนี้อย่างละเอียด\nก่อนที่ท่านจะส่งข้อมูลการเสนอราคาและข้อมูลอื่นให้แก่บริษัท ทั้งนี้\nบริษัทรับประกันจะรักษาข้อมูลทั้งหมดตามมาตรฐานความมั่นคงปลอดภัยโดยสอดคล้องกับกฎหมายที่เกี่ยวข้อง`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorIntroductionContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorIntroductionTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`For [company_name] (“the Company”)to be able to conduct procurement processes with you, please carefully review this privacy policy before submitting any quotation or other information to the Company. The Company guarantees to maintain all information in accordance with relevant laws and regulations and to the highest security standards.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorIntroductionContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Divider />
                <div className="text-purple-PHX font-semibold text-xl">
                    {t('Lawful Basis personal data')}
                </div>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorLawfulBasisTitleTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`บริษัทฯ ดำเนินการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลของท่าน โดยมีวัตถุประสงค์ภายใต้ฐานในการประมวลผลข้อมูล ดังต่อไปนี้\n\n- การปฏิบัติตามสัญญา (Contractual Basis) เพื่อการปฏิบัติตามสัญญาที่ท่านเป็นคู่สัญญา เช่น สัญญาจ้างงาน หรือสัญญาอื่นใด หรือเพื่อใช้ในการดำเนินการตามคำขอ/ใบสมัครของท่านก่อนเข้าทำสัญญา ตามแก่กรณี\n- การปฏิบัติตามกฎหมาย (Legal Obligation) เพื่อปฏิบัติหน้าที่ตามที่กฎหมายกำหนด เช่น กฎหมายคุ้มครองแรงงาน กฎหมายประกันสังคม กฎหมายเงินทดแทน กฎหมายแรงงานสัมพันธ์ กฎหมายกองทุนสำรองเลี้ยงชีพ กฎหมายภาษีอากร กฎหมายป้องกันและปราบปรามการฟอกเงิน กฎหมายคอมพิวเตอร์\n- ประโยชน์โดยชอบด้วยกฎหมาย (Legitimate Interest) เพื่อประโยชน์โดยชอบด้วยกฎหมายของบริษัทฯ โดยไม่เกินขอบเขตที่ท่านสามารถคาดหมายได้อย่างสมเหตุสมผล ซึ่งจะไม่ละเมิดสิทธิพื้นฐาน หรือสิทธิ ทางเสรีภาพของท่าน\n- ความยินยอม (Consent) บริษัทฯ จะขอความยินยอมจากท่าน กรณีที่มีกฎหมายกำหนดให้ขอความยินยอม หรือบริษัทฯ ไม่มีเหตุให้ใช้ฐานการประมวลผลข้างต้นเพื่อประมวลผลข้อมูลส่วนบุคคลที่เก็บรวบรวมมาจากท่านได้`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorLawfulBasisContentTh'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (TH)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyTH')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorLawfulBasisTitleEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('TitleOfTheTopic')} (EN)
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('RequiredField'),
                        },
                    ]}
                >
                    <Input
                        size="large"
                        showCount
                        maxLength={200}
                        placeholder={t('PlaceholderTopicEN')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    label={
                        <span className="text-sm font-bold">
                            {t('Example Data')}
                        </span>
                    }
                >
                    <div className="bg-[#F4F6FC] rounded-lg h-auto">
                        <TextBox
                            code={`The company operates by collecting, using or disclosing your personal data for the following purposes, based on the legal grounds for data processing:\n\n- Contractual Basis: To fulfill the contractual obligations that you have entered into with the company, such as employment contracts, or for the purpose of processing your requests/applications before entering into a contract.\n- Legal Obligation: To comply with legal obligations imposed on the company, such as labor laws, social security laws, compensation laws, employment relationship laws, retirement fund laws, tax laws, anti-money laundering laws, and computer laws.\n- Legitimate Interest: To pursue the legitimate interests of the company, as long as they do not unduly affect your fundamental rights or freedoms, and within the scope of what you can reasonably expect.\n- Consent: The company will seek your consent in cases where it is required by law or where the other legal grounds for processing your personal data do not apply.`}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    className="mt-4 mb-4"
                    name={'vendorLawfulBasisContentEn'}
                    label={
                        <span className="text-sm font-bold">
                            {t('Content')} (EN)
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('PleaseSpecifyEN')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    {props.editMode ? (
                        <BtnSave
                            goToStep={props.goToStep}
                            loading={props.loading}
                        />
                    ) : (
                        <div className="flex items-center">
                            <Button
                                type="default"
                                size="large"
                                onClick={onPreviousStep}
                            >
                                <ArrowLeftOutlined />{' '}
                                {t('policy.PreviousStep', {
                                    ns: 'translation',
                                })}
                            </Button>
                            <Button
                                type="primary"
                                size="large"
                                onClick={onNextStep}
                                className="ml-4"
                            >
                                {t('policy.NextStep', { ns: 'translation' })}{' '}
                                <ArrowRightOutlined />
                            </Button>
                            <div
                                style={{ borderLeft: '1px solid #DBDBDB' }}
                                className="ml-6"
                            >
                                <Button
                                    onClick={props.saveDraft}
                                    className="text-[#1890FF]"
                                    type="link"
                                >
                                    {t('Save Draft')}
                                </Button>
                                <span>{t('to save the latest changes')}</span>
                            </div>
                        </div>
                    )}
                </Sticky>
            </Form>
            <BackTop style={{ zIndex: 100000 }}>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </div>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

const initial = {
    vendorIntroductionLawfulBasisId: null,
    vendorIntroductionTitleTh: 'บทนำ',
    vendorIntroductionTitleEn: 'Introduction',
    vendorIntroductionContentTh: '',
    vendorIntroductionContentEn: '',
    vendorIntroductionIsDisplay: true,
    vendorLawfulBasisTitleTh: 'ฐานกฎหมายในการประมวลผลข้อมูลส่วนบุคคล',
    vendorLawfulBasisTitleEn: 'Lawful basis for processing personal data',
    vendorLawfulBasisContentTh: '',
    vendorLawfulBasisContentEn: '',
    vendorLawfulBasisIsDisplay: true,
};
